import React, { useMemo, useRef } from 'react';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { Carousel, ListingCardCompact, NamedLink } from '../../components';
import { createURLParamsForListing } from '../../util/listingHelpers';
import ListingService from '../../services/ListingService';
import { LOCALE_TO_LANG } from '../../constants/locales';

import css from './ListingPage.module.css';
import { useSelector } from 'react-redux';
import { useConfiguration } from '../../context/configurationContext';

const SectionMoreListingsMaybe = props => {
  const { location, listings } = props;

  const { currentUser } = useSelector(state => state.user);
  const { interfaceLang } = useSelector(state => ({ interfaceLang: state.ui.interfaceLang }));
  const config = useConfiguration();
  const intl = useIntl();
  const sliderRef = useRef();

  const handlePrev = () => {
    if (sliderRef.current) sliderRef.current.slickPrev();
  };
  
  const handleNext = () => {
    if (sliderRef.current) sliderRef.current.slickNext();
  };

  const hasListings = listings && listings.length > 0;

  const listingsInRegionCarousel = useMemo(
    () =>
      hasListings && (
        <Carousel
          ref={sliderRef}
          columns={5}
          className={css.carousel}
          contentClassName={css.carouselContent}
          showArrows={false}
        >
          {listings.map((l, i) => (
            <ListingCardCompact
              key={i}
              className={css.listingCard}
              listing={l}
              currentUser={currentUser}
              config={config}
            />
          ))}
        </Carousel>
      ),
    [config, currentUser, listings, hasListings]
  );

  if (!hasListings) return null;

  return (
    <div className={css.listingsInRegion}>
      {/* Hidden navigation links for SEO crawlers - sr-only */}
      {hasListings && (
        <nav className="sr-only" style={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          border: 0,
        }}>
          <ul>
            {listings.map(listing => {
              const locale = interfaceLang || intl.locale;
              const language = LOCALE_TO_LANG[locale] || 'english';
              const pd = listing?.attributes?.publicData || {};
              const titleFromPublicData = pd.titles && pd.titles[language];
              const generatedTitle = ListingService.createTitle(intl, listing, language);
              const title = titleFromPublicData || generatedTitle || listing?.attributes?.title || listing?.title || listing?.attributes?.name || listing?.id?.uuid;
              const urlParams = createURLParamsForListing(listing, interfaceLang);
              return (
                <li key={listing.id.uuid}>
                  <NamedLink name="ListingPage" params={urlParams}>
                    {title}
                  </NamedLink>
                </li>
              );
            })}
          </ul>
        </nav>
      )}
      <div className={css.headerRow}>
        <h2 className={css.featuresTitle}>
          <FormattedMessage id="ListingPage.moreListingsIn" values={{ location }} />
        </h2>
        <div className={css.carouselArrows}>
          <button className={css.arrowBtn} onClick={handlePrev} aria-label="Previous">
            ‹
          </button>
          <button className={css.arrowBtn} onClick={handleNext} aria-label="Next">
            ›
          </button>
        </div>
      </div>
      <div className={css.carouselWrapper}>{listingsInRegionCarousel}</div>
    </div>
  );
};

export default SectionMoreListingsMaybe;
